"use client";

import { useTranslations } from "next-intl";

export function PostventaSection() {
  const t = useTranslations("posventaSection");

  return (
    <section
      id="ayuda-posventa"
      className="bg-brand-navy px-4 section-y text-white dark:bg-surface-dark-deep"
    >
      <div className="mx-auto max-w-4xl text-center">
        <p className="text-xs font-semibold uppercase tracking-label text-gold">
          {t("eyebrow")}
        </p>
        <h4 className="mt-3 text-3xl font-black sm:text-4xl">{t("title")}</h4>
        <p className="mt-4 text-lg leading-relaxed text-mist">
          {t("subtitle")}
        </p>
        <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <a
            href="#videos-huawei"
            className="inline-flex items-center gap-2 rounded-xl bg-white px-7 py-3.5 text-sm font-bold uppercase tracking-wide text-brand-navy shadow-lg transition hover:bg-gold"
          >
            {t("huaweiCta")}
          </a>
          <a
            href="#videos-emphase"
            className="inline-flex items-center gap-2 rounded-xl bg-white px-7 py-3.5 text-sm font-bold uppercase tracking-wide text-brand-navy shadow-lg transition hover:bg-gold"
          >
            {t("emphaseCta")}
          </a>
        </div>
      </div>
    </section>
  );
}
